import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Styles.css";
import orb from "../assets/glow-orb3.png";
import { useNavigate } from "react-router-dom";

export default function HeroSection() {
  const navigate = useNavigate();
  return (
    <div className="hero-container">
      <div className="container">
        <div className="row align-items-center">
          {/* LEFT SIDE */}
          <div className="col-lg-6 hero-left">
            <h1 className="hero-title">
              Building the next <br />
              generation of <br />
              <span className="gradient-text">AI products</span>
            </h1>

            <p className="hero-desc mt-4">
              Neomonks builds intelligent, human-centered AI products that
              simplify life and unlock limitless potential.
            </p>

            {/* BUTTONS */}
            <div className="d-flex gap-3 mt-4">
              <button
                className="btn primary-btn"
                onClick={() => navigate("/products")}
              >
                Explore Products
              </button>

              <button
  className="secondary-btn"
  onClick={() => {
    document
      .getElementById("vision")
      ?.scrollIntoView({ behavior: "smooth" });
  }}
>
  Our Vision
</button>
            </div>

            {/* USERS */}
            <div className="d-flex align-items-center gap-3 mt-4">
              <div className="d-flex">
                <img src="https://i.pravatar.cc/40?img=10" className="avatar" alt="image1" />
                <img
                  src="https://i.pravatar.cc/40?img=20"
                  className="avatar overlap"
                  alt="image2"
                />
                <img
                  src="https://i.pravatar.cc/40?img=30"
                  className="avatar overlap"
                  alt="image3"
                />
                <img
                  src="https://i.pravatar.cc/40?img=55"
                  className="avatar overlap"
                  alt="image4"
                />
                <img
                  src="https://i.pravatar.cc/40?img=60"
                  className="avatar overlap"
                  alt="image5"
                />
                <div className="avatar-count overlap">10K+</div>
              </div>

              <p className="small m-0 text-muted">
                Trusted by 10,000+ early users
              </p>
            </div>
          </div>

          {/* RIGHT SIDE */}
          <div className="col-lg-6 hero-right">
            <div className="orb-container">
              <div className="neural-bg">
                <div className="wave wave1"></div>
                <div className="wave wave2"></div>
                <div className="wave wave3"></div>

                <span className="particle p1"></span>
                <span className="particle p2"></span>
                <span className="particle p3"></span>
                <span className="particle p4"></span>
                <span className="particle p5"></span>
              </div>
              <div className="network-bg">

  <svg
    className="network-svg"
    viewBox="0 0 1200 500"
    preserveAspectRatio="none"
  >

    {/* wave 1 */}
    <path
      className="network-line line1"
      d="
      M0,320
      C120,260 220,380 340,320
      S580,260 720,320
      S980,390 1200,300
      "
    />

    {/* wave 2 */}
    <path
      className="network-line line2"
      d="
      M0,360
      C180,290 260,430 420,360
      S700,300 860,360
      S1040,420 1200,340
      "
    />

    {/* wave 3 */}
    <path
      className="network-line line3"
      d="
      M0,390
      C150,330 300,460 500,390
      S820,320 980,390
      S1100,440 1200,370
      "
    />

    {/* small dots */}
    <circle cx="160" cy="300" r="3" className="network-dot" />
    <circle cx="420" cy="340" r="3" className="network-dot" />
    <circle cx="680" cy="310" r="3" className="network-dot" />
    <circle cx="920" cy="360" r="3" className="network-dot" />
    <circle cx="1050" cy="330" r="3" className="network-dot" />

  </svg>

</div>

              <img src={orb} alt="AI Orb" className="orb-image" />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
